import { Controller } from '@hotwired/stimulus';

// Cycles every nested <time> element between its three representations:
//   text content (e.g. "5 minutes ago") -> title attribute (long date) -> datetime attribute (ISO 8601)
// Representations that are blank for a given element are skipped, so each
// <time> keeps showing its last non-empty value.
//
// Usage:
//   %div{ data: { controller: "toggle-time", action: "click->toggle-time#toggle" } }
//     ... nested <time> tags ...
const MODES = ['text', 'title', 'datetime'];

export default class extends Controller {
  static values = { mode: { type: Number, default: 0 } };

  connect() {
    // Preserve the original text content, since we overwrite it while cycling.
    this.timeElements.forEach((el) => {
      if (el.dataset.timeToggleText === undefined) {
        el.dataset.timeToggleText = el.textContent.trim();
      }
    });
  }

  toggle() {
    this.modeValue = (this.modeValue + 1) % MODES.length;
    this.render();
  }

  render() {
    const mode = MODES[this.modeValue];
    this.timeElements.forEach((el) => {
      const value = this.valueFor(el, mode);
      // Skip blanks so the last displayed value stays put.
      if (value) el.textContent = value;
    });
  }

  valueFor(el, mode) {
    switch (mode) {
      case 'title':
        return (el.getAttribute('title') || '').trim();
      case 'datetime':
        return (el.getAttribute('datetime') || '').trim();
      default:
        return el.dataset.timeToggleText || '';
    }
  }

  get timeElements() {
    return Array.from(this.element.querySelectorAll('time'));
  }
}
